<form [formGroup]="addressForm" class="flex flex-col flex-1-0-auto">
    <div class="w-n-600 flex flex-col">
        <div class="flex flex-row justify-start items-start auto-flex">
            <mat-form-field appearance="outline" class="w-p-100">
                <mat-label>Street</mat-label>
                <input formControlName="Street" matInput placeholder=""
                       particleAnalytics
                       analyticsCategory="Street"
                       analyticsAction="Street-input"
                />
            </mat-form-field>
        </div>
        <div class="flex flex-row justify-start items-start auto-flex">
            <mat-form-field appearance="outline" class="w-p-100">
                <mat-label>Building</mat-label>
                <input formControlName="BuildingIdentifier" matInput placeholder=""
                       particleAnalytics
                       analyticsCategory="Street"
                       analyticsAction="BuildingIdentifier-input"
                />
            </mat-form-field>
        </div>
        <div class="flex flex-row justify-start items-start auto-flex">
            <mat-form-field appearance="outline" class="w-p-100">
                <mat-label>Suite</mat-label>
                <input formControlName="SuiteIdentifier" matInput placeholder=""
                       particleAnalytics
                       analyticsCategory="SuiteIdentifier"
                       analyticsAction="SuiteIdentifier-input"
                />
            </mat-form-field>
        </div>
        <div class="flex flex-row justify-start items-start auto-flex">
            <mat-form-field appearance="outline" class="w-p-100">
                <mat-label>Floor</mat-label>
                <input formControlName="FloorIdentifier" matInput placeholder=""
                       particleAnalytics
                       analyticsCategory="FloorIdentifier"
                       analyticsAction="FloorIdentifier-input"
                />
            </mat-form-field>
        </div>
        <div class="flex flex-row justify-start items-start auto-flex">
            <mat-form-field appearance="outline" class="w-p-100">
                <mat-label>District Name</mat-label>
                <input formControlName="DistrictName" matInput placeholder=""
                       particleAnalytics
                       analyticsCategory="DistrictName"
                       analyticsAction="DistrictName-input"
                />
            </mat-form-field>
        </div>
        <div class="flex flex-row justify-start items-start auto-flex">
            <mat-form-field appearance="outline" class="w-p-100">
                <mat-label>Post Office Box POB</mat-label>
                <input formControlName="PostOfficeBoxPOB" matInput placeholder=""
                       particleAnalytics
                       analyticsCategory="PostOfficeBoxPOB"
                       analyticsAction="PostOfficeBoxPOB-input"
                />
            </mat-form-field>
        </div>
        <div class="flex flex-row justify-start items-start auto-flex">
            <mat-form-field appearance="outline" class="w-p-100">
                <mat-label>Post Code</mat-label>
                <input formControlName="PostCode" matInput placeholder=""
                       particleAnalytics
                       analyticsCategory="PostCode"
                       analyticsAction="PostCode-input"
                />
            </mat-form-field>
        </div>
        <div class="flex flex-row justify-start items-start auto-flex">
            <mat-form-field appearance="outline" class="w-p-100">
                <mat-label>City</mat-label>
                <input formControlName="City" matInput placeholder="" required
                       particleAnalytics
                       analyticsCategory="City"
                       analyticsAction="City-input"
                />
                <mat-error *ngIf="addressFormErrors.City.required">
                    City is required!
                </mat-error>
            </mat-form-field>
        </div>
        <div *ngIf="countryList" class="flex flex-row justify-start items-start auto-flex">
            <mat-form-field appearance="outline" class="flex-0-0-100">
                <mat-label>Country</mat-label>
                <mat-select formControlName="Country" required>
                    <mat-option *ngFor="let country of countryList" [value]="country.code">
                        {{country.name}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="addressFormErrors.Country.required">
                    Country is required!
                </mat-error>
            </mat-form-field>
        </div>
    </div>
</form>

